import React, { useEffect } from "react";
import {
  useGetAllCoursesByClusterQuery,
  useGetStudentByEmailIdQuery,
} from "../../../graphql/generated.tsx";
import { useNavigate } from "react-router-dom";

const RECOMMENDED_CLUSTER_ID = "56eed915-cb4f-4bf6-ae18-18a1ad18f281";
const RECOMMENDED_CAMPUS_NAME = "BT";

const RecommendedCourseCards = ({ courseid, setIsRecommendedEmpty }) => {
  const navigate = useNavigate();
  const email = JSON.parse(localStorage.getItem("user"))?.email;

  const { data: studentData, loading: studentDataLoading } =
    useGetStudentByEmailIdQuery({
      variables: { email },
    });
  const purchasedCourses =
    studentData?.getStudentByEmailId?.purchasedCourses || [];
  const { data: onlineCourse, loading: loadingAllCourses } =
    useGetAllCoursesByClusterQuery({
      variables: {
        clusterId: RECOMMENDED_CLUSTER_ID,
        campusName: RECOMMENDED_CAMPUS_NAME,
      },
    });

  const purchasedCourseIds = purchasedCourses.map((course) => course.course_id);

  const filteredOnlineCourses =
    onlineCourse?.getAllCoursesByCluster?.filter(
      (course) =>
        !purchasedCourseIds.includes(course.id)
    ) || [];

  const courses = filteredOnlineCourses.filter(
    (course) => course.id !== courseid
  );

  useEffect(() => {
    // Show sidebar only when loading completes and decide empty state
    if (!loadingAllCourses && !studentDataLoading) {
      setIsRecommendedEmpty(courses.length === 0);
    }
  }, [courses, loadingAllCourses, studentDataLoading, setIsRecommendedEmpty]);

  if (loadingAllCourses || studentDataLoading) {
    return null;
  }

  return (
    <div className="hidden md:block w-[25%]">
      <div className="h-[70%] p-5">
        <div className="overflow-y-auto">
          {courses.length != 0 && (
            <>
              <h1 className="text-xl font-bold mb-2">Recommended Courses</h1>
              <div className="w-full h-full overflow-y-auto space-y-4">
                {courses.map((item) => (
                  <div
                    key={item.id}
                    className="bg-white p-4 rounded-lg shadow-md border border-black flex flex-col justify-between hover:shadow-lg transition-shadow duration-300 min-h-[200px]"
                  >
                    <h3 className="font-bold text-lg">{item.name}</h3>
                    <div className="flex w-full flex-wrap sm:flex-nowrap justify-between items-center gap-4 py-2">
                      <span className="inline-block bg-blue-100 text-blue-800 text-sm font-medium px-3 py-1 rounded">
                        {item.level}
                      </span>
                    </div>
                    <p className="text-gray-600 mt-2 text-sm">
                      {item.short_description}
                    </p>
                    <div className="flex-grow"></div>
                    <button
                      className="mt-3 w-full rounded-lg bg-gradient-to-r from-blue-500 to-blue-700 px-4 py-1.5 font-semibold text-white shadow-md transition-all duration-300 hover:from-blue-600 hover:to-blue-800"
                      onClick={() =>
                        navigate(
                          `/student/courses/${RECOMMENDED_CLUSTER_ID}/${item.id}`
                        )
                      }
                    >
                      Avail Now
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecommendedCourseCards;
